<template>
    <div class="my-5">
        <div class="container-fluid">
            <div class="tagis-content-container" v-if="this.subEntity.displayContents">
                <div v-for="dataToView of this.subEntity.displayContents" :key="dataToView">
                    <div class="overall-champs">
                        <h2>{{ dataToView.title }}</h2>
                        <div class="d-flex flex-column gap-3" v-if="this.entity[dataToView.entityDataName].length > 0">
                            <div class="win-container d-flex w-100 flex-row gap-4 py-3 px-3 align-items-center  rounded-3"
                                v-for="win, index of this.entity[dataToView.entityDataName]" :key="index">
                                <div class="bg-black rounded-circle overflow-hidden p-1 ">
                                    <img :src="this.subEntity.icons[getValuebykey(this.subEntity.heroList, win.hero_id)]"
                                        style="width:50px;height:50px;object-fit: cover;" alt="">
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center flex-grow-1">
                                <div class="d-flex flex-column">
                                    <h4 class="lh-1">{{ win.entity_name }}</h4>
                                    <span>Student ID: <span class="text-secondary">{{ win.entity_id }}</span></span>
                                </div>
                                <h5 class="">Points: <span class="text-secondary">{{ win.points }}</span></h5>
                                </div>

                            </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center" v-else>
                            <h4 class="h2">* * * No Records * * *</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TagisLakas",
        methods: {
            getValuebykey(obj, value) {
                return Object.keys(obj).find(key => obj[key] === value)
            }
        },
        props: {
            entity: Object,
            subEntity: Object
        },
    }
</script>

<style></style>